import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import AdmitStatusService from "../../../Services/AdmitStatus.service";
import AdmitStatusLookupModal from "./AdmitStatusLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => AdmitStatusService.search({
        ids: options === null || options === void 0 ? void 0 : options.ids,
        query: search || (options === null || options === void 0 ? void 0 : options.query),
        names: options === null || options === void 0 ? void 0 : options.names,
        srcSystemIds: options === null || options === void 0 ? void 0 : options.srcSystemIds,
    }, { max: 20 }).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const AdmitStatusSearch = makeSearch(makeSearchArgs);
export const AdmitStatusMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { 
    // @ts-expect-error - TS2322 - Type 'ComponentType<WithModalParams<LookupModalProps<AdmitStatus, any>>>' is not assignable to type 'ComponentType<never> | undefined'.
    lookupModal: AdmitStatusLookupModal }));
